module.exports = __webpack_public_path__ + "img/hero_bg_mobile.9fcae09.jpg";